const featuredBlogsSwiper = new Swiper(".featured-blog-posts-swiper", {
  slidesPerView: 1,
  spaceBetween: 12,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
    dynamicMainBullets: 3,
  },
  breakpoints: {
    500: {
      slidesPerView: 2,
    },
    800: {
      slidesPerView: 3,
    },
    1000: {
      slidesPerView: 4,
    },
  },
});

// let categoryDropdown = document.getElementById("categoryDropdown");
// let categoryContainer = document.querySelectorAll(".categoryContainer");
// let currentSelectedOption = null;

// categoryDropdown.addEventListener("change",function(el) {
// currentSelectedOption = el.target.value;

//   for(let i = 0; i < categoryContainer.length; i ++) {
//     categoryContainer[i].style.display = "none";
// if(categoryContainer[i].classList.contains(currentSelectedOption)) {
//   console.log(categoryContainer[i]);
// categoryContainer[i].style.display = "block";
// }
// }
//  })

document.addEventListener("DOMContentLoaded", function () {
  var garageAjaxinate = new Ajaxinate({
    container: "#garageAjaxinateContainer",
    pagination: "#garageAjaxinatePagination",
    method: "scroll",
    offset: 1000,
  });

  //   var newsAndEventsAjaxinate = new Ajaxinate({
  //   container: '#newsAndEventsAjaxinateContainer',
  //   pagination: '#newsAndEventsAjaxinatePagination',
  //   method: 'scroll',
  //   offset: 1000
  // });

  // var carWorldAjaxinate = new Ajaxinate({
  //   container: '#carWorldAjaxinateContainer',
  //   pagination: '#carWorldAjaxinatePagination',
  //   method: 'scroll',
  //   offset: 1000
  // });

  // var howToAjaxinate = new Ajaxinate({
  //   container: '#howToAjaxinateContainer',
  //   pagination: '#howToAjaxinatePagination',
  //   method: 'scroll',
  //   offset: 1000
  // });

  //   var tipsAndTricksAjaxinate = new Ajaxinate({
  //   container: '#tipsAndTricksAjaxinateContainer',
  //   pagination: '#tipsAndTricksAjaxinatePagination',
  //   method: 'scroll',
  //   offset: 1000
  // });

  //   var comparisonsAjaxinate = new Ajaxinate({
  //   container: '#comparisonsAjaxinateContainer',
  //   pagination: '#comparisonsAjaxinatePagination',
  //   method: 'scroll',
  //   offset: 1000
  // });
});

// function formatArticlePublishDates() {
//   let allArticleDate = document.getElementsByTagName("time");
//   for(let i = 0; i < allArticleDate.length; i ++) {
//   allArticleDate[i].textContent = convertDateToText(allArticleDate[i].textContent.split(" ")[0])
//   }
//   function convertDateToText(date) {
//     return new Date(date).toLocaleString('en-us',{month:'short', day:'numeric',})
//    }
// }
// formatArticlePublishDates();

function formatArticlePublishDates() {
  this.textContent = convertDateToText(this.textContent.split(" ")[0]);
  function convertDateToText(date) {
    return new Date(date).toLocaleString("en-us", {
      month: "short",
      day: "numeric",
    });
  }
}
// formatArticlePublishDates();

//slider functions
function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createDiv("arrow arrow--left");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowRight = createDiv("arrow arrow--right");
    arrowRight.addEventListener("click", () => slider.next());

    wrapper.appendChild(arrowLeft);
    wrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("navigation-wrapper");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv("dots");
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createDiv("dot");
      dot.addEventListener("click", () => slider.moveToIdx(idx));
      dots.appendChild(dot);
    });
    wrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });
  slider.on("optionsChanged", () => {
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
  });
}

// var slider = new KeenSlider(
//   "#my-keen-slider",
//   {
//     breakpoints: {
//       "(min-width: 500px)": {
//         slides: { perView: 2, spacing: 5 },
//       },

//       "(min-width: 800px)": {
//         slides: { perView: 3, spacing: 10 },
//       },
//       "(min-width: 1000px)": {
//         slides: { perView: 4, spacing: 10 },
//       },
//     },
//     slides: { perView: 1 },
//     loop: true,
//   },
//   [navigation]
// );

// scroll to top progress bar
// let calcScrollValue = () => {
//   let scrollProgress = document.getElementById("progress");
//   let progressValue = document.getElementById("progress-value");
//   let pos = document.documentElement.scrollTop;
//   let calcHeight =
//     document.documentElement.scrollHeight -
//     document.documentElement.clientHeight;
//   let scrollValue = Math.round((pos * 100) / calcHeight);
//   if (pos > 100) {
//     scrollProgress.style.display = "grid";
//   } else {
//     scrollProgress.style.display = "none";
//   }
//   scrollProgress.addEventListener("click", () => {
//     document.documentElement.scrollTop = 0;
//   });
//   scrollProgress.style.background = `conic-gradient(#2863ec ${scrollValue}%, #fff ${scrollValue}%)`;
// };
// window.onscroll = calcScrollValue;
// window.onload = calcScrollValue;
